import { titleize } from '@common/helpers/strings';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import AgentsRegionPageContent from 'sly/agentsRegionPage/AgentsRegionPageContent';
import { usePrefetch } from 'sly/services/api';
import { pageNames, useEvents } from 'sly/services/events';

function AgentsRegionPage() {
  const { events } = useEvents();
  useEffect(() => {
    events.page(pageNames.AgentsRegion, {});
  }, []);
  const router = useRouter();
  const {
    requestInfo: { normalized },
  } = usePrefetch('getAgentsNew', {
    'filter[region]': router.query.region,
    'filter[status]': 'gt:0',
    include: 'address,gallery,gallery.images',
    'page-size': 100,
  });

  if (!router.query.region || !normalized) {
    return (
      <div data-tp-id='gen-div-2c084035-decd-4469-9332-833f636c6f06'>
        loading
      </div>
    );
  }

  const locationName = titleize(router.query.region || 'test');
  const title = `${locationName} Partner Agents`;
  const citySlug = router.query.city;

  return (
    <AgentsRegionPageContent
      agentsList={normalized}
      title={title}
      locationName={locationName}
      isRegionPage={!citySlug}
    />
  );
}

export default AgentsRegionPage;
